export default __webpack_public_path__ + "static/media/210430-Cloudxier Clients Logo-14.5c5218db.png";